module.exports = __webpack_public_path__ + "static/media/mobileoi.6e60fb57.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/OI Modal/mobileoi.png
// module id = 866
// module chunks = 0